export default "__VITE_ASSET__D$LtoMQw__"